import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, light = false }) => (
  <div
    className={`flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] ${
      light ? "text-brand-orange" : "text-brand-orange"
    }`}
  >
    <span className="h-px w-10 bg-brand-orange" />
    <span>{children}</span>
  </div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block -mb-[0.2em] overflow-hidden ${className}`}>
    <motion.span
      className="block pb-[0.2em] will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export default Reveal;
